import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
var useStyles = makeStyles(function (theme) {
  return {
    popover: {
      pointerEvents: "none"
    },
    paper: {
      padding: theme.spacing(1)
    }
  };
});

var MouseOverPopover = function MouseOverPopover(_ref) {
  var message = _ref.message,
      children = _ref.children;
  var classes = useStyles();

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var handlePopoverOpen = function handlePopoverOpen(event) {
    setAnchorEl(event.currentTarget);
  };

  var handlePopoverClose = function handlePopoverClose() {
    setAnchorEl(null);
  };

  var open = Boolean(anchorEl);
  var cloneChildren = React.cloneElement(children, {
    onMouseEnter: handlePopoverOpen,
    onMouseLeave: handlePopoverClose
  });
  return /*#__PURE__*/React.createElement("div", null, cloneChildren, /*#__PURE__*/React.createElement(Popover, {
    id: "mouse-over-popover",
    className: classes.popover,
    classes: {
      paper: classes.paper
    },
    open: open,
    anchorEl: anchorEl,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    },
    onClose: handlePopoverClose,
    disableRestoreFocus: true
  }, /*#__PURE__*/React.createElement(Typography, null, message)));
};

export { MouseOverPopover };